import * as React from "react";
import { casesActions } from "configs";
import {
  FormWatcherCallback,
  useParams,
  useDispatch,
  useCurrentCase
} from "duck";
import { useUpdateVaccineMutation, Fragments } from "requests";
import { FormValues } from "./types";

export const useUpdateVaccines = (initialValues: Fragments.StoredVaccines) => {
  const { id: caseId } = useParams();
  const dispatch = useDispatch();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  const [updateVaccine] = useUpdateVaccineMutation({ ignoreResults: true });

  return React.useCallback<FormWatcherCallback<FormValues>>(
    values => {
      const updates = Object.keys(values)
        .map(key => {
          const initVaccine = initialValues.find(v => v.vaccine === key);
          if (!initVaccine) {
            return;
          }
          return {
            _id: initVaccine._id,
            fakeId: initVaccine.fakeId,
            toPerform: ((values as any)[key] || false) as boolean
          };
        })
        .filter(Boolean) as Fragments.StoredVaccines;

      dispatch(casesActions.updateVaccines({ _id: caseId, data: updates }));

      if (shouldSync) {
        return Promise.all(
          updates.map(upd =>
            upd._id != null
              ? updateVaccine({ variables: { input: upd } })
              : Promise.resolve({})
          )
        );
      }
    },
    [updateVaccine, shouldSync, initialValues]
  );
};
